module.exports = __webpack_public_path__ + "shattered.ea2316224d45899c59bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/patterns/shattered.png
// module id = 1043
// module chunks = 2